import React from 'react';

const OpenWhenVisual = ({ revealMeta = {} }) => {
  const stack = (revealMeta.letterStack?.length ?
    revealMeta.letterStack :
    ['Miss Me', 'Need Courage', 'Birthday']).slice(0, 4);

  return (
    <span className="lumirae-layer-visual lumirae-layer-visual-open-when" aria-hidden="true">
      {stack.map((label, index) => (
        <span key={`${label}_${index}`} className={`open-envelope open-envelope-${index}`}>
          <b>{label}</b>
          <i />
        </span>
      ))}
      <span className="floating-note">
        <strong>{revealMeta.displayTitle || 'Open When'}</strong>
        <small>{revealMeta.letterCount ? `${revealMeta.letterCount} sealed notes` : 'Sealed note'}</small>
        <i />
        <i />
      </span>
    </span>
  );
};

export default OpenWhenVisual;
